import { LLMModelUnitPriceInput } from '../../../types/admin';

export function findDuplicateUnitPriceIdentities(rows: LLMModelUnitPriceInput[]): string[] {
  const seen = new Set<string>();
  const duplicates = new Set<string>();
  rows.forEach((row) => {
    const identity = unitPriceIdentity(row);
    if (seen.has(identity)) duplicates.add(identity);
    seen.add(identity);
  });
  return [...duplicates];
}

export function unitPriceIdentity(row: LLMModelUnitPriceInput): string {
  return `${row.unitType}|${canonicalCondition(row.condition)}`;
}

export function canonicalCondition(
  condition?: Record<string, string | number | boolean> | null
): string {
  if (!condition || Object.keys(condition).length === 0) return '';
  return JSON.stringify(
    Object.keys(condition)
      .sort()
      .reduce<Record<string, string | number | boolean>>((result, key) => {
        result[key] = condition[key];
        return result;
      }, {})
  );
}
